import React from 'react';

import styles from './ErrorElement.module.scss';

interface ErrorElementProps {
  errors: any;
}

export const ErrorElement: React.FC<ErrorElementProps> = ({ errors }) => {
  return (
    <>
      Status: <span className={styles.error}>{errors.general}</span>
    </>
  );
};
